






















































































import { Component, Prop } from 'vue-property-decorator';
import { GripBarrier } from '../../../store/types/grip.types';
import BasePagination from '../../../components/base/BasePagination.vue';
import { PaginationMixin } from '../../../components/base/pagination.mixin';
import { mixins } from 'vue-class-component';
import { getUpperCase } from '../../../utils/general.util';

@Component({
  components: { BasePagination },
})
export default class BarrierList extends mixins(PaginationMixin) {
  @Prop() public items!: GripBarrier[];
  @Prop(Number) public totalNumberOfPage!: number;
  @Prop(Number) public totalCount!: number;
  @Prop(Boolean) public isFirstPage!: boolean;
  @Prop(Boolean) public isLastPage!: boolean;
  @Prop(Number) public startItemIndex!: number;
  @Prop(Number) public endItemIndex!: number;
  // Receive the ID of the barrier currently being edited from the parent
  @Prop({ type: Number, default: null }) public editingBarrierId!:
    | number
    | null;
  // Receive the minimized state from the parent
  @Prop({ type: Boolean, default: false }) public isMinimized!: boolean;

  get projectId(): number {
    return +this.$route.params.projectId;
  }

  public getUpperCase(value: string) {
    return getUpperCase(value);
  }

  public handleEdit(barrier: GripBarrier): void {
    // Instead of opening a local modal, emit an event with the barrier data
    this.$emit('edit-barrier', barrier);
  }
}
